import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import { config, isLocalDev } from "./getFirebaseConfig";

const firebaseApp = !firebase.apps.length
  ? firebase.initializeApp(config)
  : firebase.app();

const functions_region = "europe-west1"; // https://firebase.google.com/docs/functions/locations

export const persistence = isLocalDev
  ? firebase.auth.Auth.Persistence.LOCAL
  : firebase.auth.Auth.Persistence.SESSION;
export const auth = firebaseApp.auth();
export const db = firebaseApp.firestore();
export const func = firebaseApp.functions(functions_region);

if (isLocalDev) {
  func.useFunctionsEmulator(process.env.FIREBASE_DB_URL);
}
